<template>
  <div>
    <form data-vv-scope="Inventory" class="px-4">
      <!-- {{ASSETS_MODULE}}
      {{repository_id}} -->
      <!-- <pre> {{ editingObject }}</pre> -->
      <!-- <pre>{{errors}}</pre> -->
      <!-- {{categoryList}}
      {{category_id}} -->
      <!-- <span v-if="editingObject">True</span> -->
      <div class="vx-row">
        <p v-if="asset_codes" class="m-4"><strong>Assets Codes : {{ asset_codes}}</strong></p>
        <div class="vx-col w-full">
          <div class="mb-4">
            <label class="vs-input--label">Category List <span class="required"></span></label>
            <v-select
          v-validate="'required'"
              class="w-full"
              label="category_name"
              :reduce="(option) => option.assets_categories_id"
              :options="categoryList"
              v-model="category_id"
              :clearable="false"
              data-vv-name="Category Name"
              name="Category Name"
            >
              <template #list-footer>
                <li style="margin-left: 15px; cursor: pointer">
                  <span
                    style="color: rgba(var(--vs-primary), 1); margin-left: 3px"
                    @click="categoryAssetPopUp = true"
                    >Add New Category</span
                  >
                </li>
              </template>
            </v-select>
            <div
              v-if="errors.has('Inventory.Category Name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Inventory.Category Name") }}
            </div>
          </div>

          <div class="mb-4">
            <label class="vs-input--label">Inventory Name <span class="required"></span></label>
            <!-- <vs-input
              label="Inventory Name"
              class="w-full requiredInput"
              v-model="name"
              v-validate="'required'"
              data-vv-name="Inventory Name"
            /> -->
            <v-select
          v-validate="'required'"
              class="w-full"
              label="name"
              :reduce="(option) => option.name"
              :options="inventoryList"
              v-model="name"
              :clearable="false"
              data-vv-name="Inventory Name"
              name="Inventory Name"
            >
              <template #list-footer>
                <li style="margin-left: 15px; cursor: pointer">
                  <span
                    style="color: rgba(var(--vs-primary), 1); margin-left: 3px"
                    @click="inventoryAssetPopUp = true"
                    >Add New Inventory</span
                  >
                </li>
              </template>
            </v-select>
            <div
              v-if="errors.has('Inventory.Inventory Name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Inventory.Inventory Name") }}
            </div>
          </div>

          <div class="mb-4">
            <vs-input
              label="Inventory Details"
              class="w-full"
              v-model="asset_details"
              data-vv-name="inventory_details"
            />
          </div>
         <!--  <div
            v-if="errors.has('Inventory.inventory_details')"
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first("Inventory.inventory_details") }}
          </div> -->
          <div class="mb-4">
            <label class="vs-input--label">Inventory Type<span class="required"></span></label>
            <v-select
              class="w-full"
              :options="inventoryOptions"
              label="name"
              v-model="inventory_type"
              :reduce="(item) => item.id"
              v-validate="'required'"
              data-vv-name="inventory type"
              :class="{ disabled: editingObject ? true : false }"
            />
            <div
              v-if="errors.has('Inventory.inventory type')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Inventory.inventory type") }}
            </div>
          </div>

         <!--  <vs-input
            v-if="inventory_type === 1"
            label="Assets Codes"
            class="mb-4 w-full requiredInput"
            v-model="asset_codes"
            v-validate="'required'"
            data-vv-name="assets_codes"
          />
          <div
            v-if="inventory_type === 1 && errors.has('Inventory.assets_codes')"
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first("Inventory.assets_codes") }}
          </div> -->

          <div class="mb-4">
            <vs-input
              v-if="inventory_type === 0"
              label="Quantity"
              class="w-full requiredInput"
              v-model="quantity"
              v-validate="'required|numeric'"
              data-vv-name="Inventory Quantity"
            />
            <div
              v-if="
                inventory_type === 0 && errors.has('Inventory.Inventory Quantity')
              "
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Inventory.Inventory Quantity") }}
            </div>
          </div>

          <div class="suitableTagHolder focusHolder mb-4">
            <label class="w-full vs-input--label">Suitable For (Type the name and press enter)</label>
            <!-- <span>Please Hit Enter after inserting suitable tag </span> -->
            <span
              class="tag-badge"
              v-for="(suitableTag, index) in suitable_for"
              :key="index"
            >
              <span>{{ suitableTag }}</span>
              <a @click="deleteTag(index)">&times;</a>
            </span>
            <vs-input class="w-full" v-model="suitable" @keyup.enter="addTags" />
          </div>
          <!-- {{suitable}}
            <label class="w-full vs-input--label">Suitable For: </label>
            <v-select class="mb-4 w-full" taggable multiple push-tags v-model="suitable" /> -->

          <div class="mb-4">
            <vs-input
              class="w-full requiredInput"
              label="Inventory Price"
              v-model="price"
              v-validate="'required|numeric'"
              data-vv-name="Inventory Price"
            />
            <div
              v-if="errors.has('Inventory.Inventory Price')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Inventory.Inventory Price") }}

              <!-- <vs-input
                  class="mb-4 pl-2 w-1/2 requiredInput"
                  placeholder="Per Hour"
                /> -->
            </div>
          </div>

          <div>
            <label class="vs-input--label">Attach Images</label>
<!-- {{oldImages}}
 v-if="
                editingObject &&
                oldImages &&
                oldImages.length
              "
 -->
 <!-- {{files}} -->
            <div
              class="flex flex-wrap align-center"
                           v-if="files.length"

            >
              <div
                v-for="(eachImage, index) in files"
                :key="index"
                style="margin:5px"
              >
              <vs-radio v-model="eachImage.is_default" vs-name="radios" vs-value="1"
              @change="selectDefaultImage(index)"
              />
                <vs-card class="imageholdercontainer">
                  <img
                    :src="eachImage.file_image_url"
                    width="200"
                    height="200"
                  />
                  <vs-tooltip text="Remove this Picture">
                    <vs-button
                      radius
                      color="primary"
                      type="border"
                      icon="delete"
                      class="deleteIcon"
                      @click="deleteFile(index,eachImage)"
                    ></vs-button>
                  </vs-tooltip>
                </vs-card>
              </div>
            </div>
          </div>

          <!-- <file-upload-component></file-upload-component> -->
          
        </div>
      </div>

      <file-upload-component
            :files="files"
            :deletedFile="deletedFile"
            @getImage="getImage"
            @removeImageEvent="removeImage"
            :file_repository_id="repository_id"
            types="Inventory"
          ></file-upload-component>

      <div class="flex mt-5 justify-end">
        <vs-button
          color="primary"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="createNewRoom()"
        >
          <span v-if="!editingObject">Create Inventory</span>
          <span v-else>Update Inventory</span>
        </vs-button>
        <vs-button
          color="danger"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="handleCloseSidebar()"
          >Cancel</vs-button
        >
      </div>
    </form>

    <vs-popup
      title="Category"
      :active.sync="categoryAssetPopUp"
      class="category-pop"
    >
      <category-asset-component
        @gettingNewCategory="gettingNewCategory"
      ></category-asset-component>
    </vs-popup>

    <vs-popup
      title="Inventory"
      :active.sync="inventoryAssetPopUp"
      class="category-pop"
    >
      <div>
    <form data-vv-scope="InventoryName" class="">
      <vs-input
        label="Inventory Name"
        class="mb-4 w-full requiredInput"
        v-model="inventory_name"
        v-validate="'required'"
        data-vv-name="Inventory Name"
      />
      <div
        v-if="errors.has('InventoryName.Inventory Name')"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first("InventoryName.Inventory Name") }}
      </div>
      <div class="flex mt-5 justify-end">
        <vs-button
          color="primary"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="creatingAssetInventory()"
        >
          Create Inventory
        </vs-button>
      </div>
    </form>
  </div>
    </vs-popup>
  </div>
</template>

<script>
import { createInventoryApi, updateInventory, fetchingInventoryNameApi } from '@/api/room.js'
import { roomInventory } from '@/mixins/Rooms/roomInventory.js'
import vSelect from 'vue-select'
import FileUploadComponent from './FileUploadComponent.vue'
import categoryAssetComponent from './CategoryAssetComponent'
import { repository } from '@/mixins/repository'

export default {
  components: {
    vSelect,
    FileUploadComponent,
    categoryAssetComponent
  },
  name: 'InventoryCreate',
  mixins: [roomInventory, repository],
  data () {
    return {
      category_name: '',
      inventoryAssetPopUp: false,
      inventoryList: [],
      inventory_name: '',
      asset_types: 'Inventory',
      assets_id: null,
      category_id: '',
      platform_module_id:44
    }
  },
  props: {
    editingObject: {
      default: () => null
    }
  },
  watch: {
    name () {
      if (this.name !== '') {
          const filteredData = this.inventoryList.filter ((ele) => {
            return ele.name === this.name
          })
          if (filteredData[0].id !== null) {
            if (filteredData.length !== 0) {
              this.category_id = filteredData[0].assets_categories_id
              this.inventory_type = filteredData[0].inventory_type
              this.price = filteredData[0].price
            }
        }
    }
  }
  },

  created () {
    this.getRepositoryId(this.platform_module_id)
    this.fetchingInventoryName()
    this.fetchingAssetsCategory()
    if (this.editingObject) {
      
      
      this.assets_id = this.editingObject.assets_id
      this.asset_details = this.editingObject.asset_details

      this.category_id = this.editingObject.assets_categories_id
      this.asset_codes = this.editingObject.asset_codes
      this.oldImages = [...this.editingObject.asset_images]

      // 
      
      // =this.editingObject.asset_images
      // =this.editingObject.asset_tags
      this.inventory_type = this.editingObject.inventory_type
      this.name = this.editingObject.name
      this.price = this.editingObject.price
      this.quantity = this.editingObject.quantity
      this.suitable_for = this.editingObject.asset_tags.map(
        (ele) => ele.tag_name
      )
      this.files = this.editingObject.asset_images.map((ele) => {
        return {
          files_id: ele.files_id,
          files_repository_id: ele.files_repository_id,
          file_image_url:ele.files_details.file_path,
          is_default:ele.is_default
        }
      })
    } else {
      
    }
  },

  methods: {
    gettingNewCategory (newCategory) {
      this.categoryList.push(newCategory)
      this.category_id = newCategory.assets_categories_id
      this.categoryAssetPopUp = false
    },
    creatingAssetInventory () {
      this.$validator.validateAll('InventoryName').then((valid) => {
        if (valid) {
          this.name = this.inventory_name
          this.inventoryList.push({name: this.inventory_name, id: null})
          this.inventoryAssetPopUp = false
        } else {
          this.showSuccessMessage(
            'Warning',
            'Mandatory Field is Requiered',
            'danger'
          )
        }
      })
     
    },
    async fetchingInventoryName () {
      try {
        this.$vs.loading({
          text:'Fetching Inventory List'
        })
        const customer_id = this.$store.getters.customerId
        const inventory = await fetchingInventoryNameApi(customer_id)
        this.inventoryList = inventory.data.data.assets_list
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    async createNewRoom () {
      const validateParent = this.$validator.validateAll('Inventory')

      validateParent.then((valid) => {
        if (valid) {
          /*  if (this.files.length === 0) {
            this.showSuccessMessage(
              'Warning',
              'Atleast Attached One files',
              'danger'
            )
          }  */
      

          const hasCheckingDefault = this.checkingDefaultValue()

          if (hasCheckingDefault) {
             
            this.creatingNewInventory()

          } else {
            this.showSuccessMessage(
              'Warning',
              'Please select image as default image',
              'danger'
            )
          }
        } else {
          this.showSuccessMessage(
            'Warning',
            'Validation Field is Required',
            'danger'
          )
        }
      })
    },
    async creatingNewInventory () {
      const customer_id = this.$store.getters.customerId
      let text = ''
      if (!this.editingObject) {
        text = 'Creating New Inventory'
      } else {
        text = 'Updating Inventory ...'
      }
      try {
        this.$vs.loading({
          text
        })
        const payload = {
          customer_id,
          asset_types: this.asset_types,
          name: this.name,
          price: this.price,
          inventory_type: this.inventory_type,
          quantity: this.quantity,
          suitable_for: this.suitable_for,
          asset_details: this.asset_details,
          files: this.files,
          price_type: this.price_type,
          assets_categories_id: this.category_id,
          asset_codes: this.asset_codes
        }
        if (this.inventory_type === 1) {
          payload.quantity = 1
        } else {
          delete payload.asset_codes
        }
        
        if (this.assets_id) {
          payload.assets_id = this.assets_id
          const response = await updateInventory(payload)
          // 
          this.$emit(
            'createdNewInventory',
            response.data.data.assets_details,
            this.assets_id
          )
          this.showSuccessMessage(
            'Success',
            'Inventory Updated successfully',
            'success'
          )
        } else {
          const response = await createInventoryApi(payload)
          

          this.showSuccessMessage(
            'Success',
            'New Inventory Created successfully',
            'success'
          )
          this.$emit('createdNewInventory', response.data.data.assets_details)
        }
      } catch (error) {
        
        if ('data' in error) {
          
          this.showSuccessMessage('Success', `${error.data.message}`, 'danger')
        }
        // 
      } finally {
        this.$vs.loading.close()
      }
    },
    handlcreateSidebar () {
      
    }
  },
  beforeDestroy () {
    this.assets_id = null
  }
}
</script>

<style scoped>
.category-pop {
  z-index: 100000 !important;
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  /* background-color: #eef1f6;
  border-color: #d1dbe5; */
}
.imageholdercontainer {
  position: relative;
}
.imageholdercontainer .deleteIcon {
  position: absolute;
  top: 0;
  right: 0;
}
.required:after {
  content: " *";
  color: red;
}
</style>